export default function modalResponseRender(modalSentSelector, response, title, customResponse = false){
    let responseModal = $(modalSentSelector);
    let responseModalIcon   = responseModal.find('.icon');
    let responseModalDesc  = responseModal.find('.message');
    let responseModalTitle  = responseModal.find('.modal-title');

    responseModalIcon.addClass(response.detail.status);
    responseModalTitle.text(title);
    if(customResponse){
        let responeMessage = customResponse.replace('{user-email}', response.detail.inputs.find(el => el.name == 'user-email').value)
        responseModalDesc.html(responeMessage)
    }else{
        responseModalDesc.text(response.detail.apiResponse.message);
    }
        

    responseModal.modal('show');

    responseModal.on('hide.bs.modal', function () {
        responseModalIcon.removeClass(response.detail.status);
        responseModalTitle.text('');
        responseModalDesc.text('');
    })
}